import { sharedUrls } from './environment.urls';
import { REVISION, VERSION } from './revision';

export const environment = {
  gtmContainerId: 'GTM-WZXPXV73',
  analyticsEnv: 'dev',
  firebase: {
    apiKey: 'AIzaSyBmb9sPZy5O5K4ziqJuhm3mqFLmZFWD2u0',
    authDomain: 'spog-gopher-develop.firebaseapp.com',
    projectId: 'spog-gopher-develop',
    storageBucket: 'spog-gopher-develop.firebasestorage.app',
    messagingSenderId: '848861775180',
    appId: '1:848861775180:web:75d31f83c6cf88827abbe9',
  },
  urls: {
    backendApi: 'https://spog-backend.dev.gopher.cdw.com/api',
    ...sharedUrls,
  },
  production: false,
  revision: REVISION,
  version: VERSION,
};
